import React from "react"
import { CheckCircleOutlined, CloseCircleOutlined, HourglassOutlined, SyncOutlined } from "@ant-design/icons"
import { Select, Tag } from "antd";

const SelectStatusCustom = ({ status, onChange, customStyle }) => {

    return (
        <Select
            value={status}
            onChange={onChange}
            style={customStyle ?? { width: "100%" }}
        >
            <Select.Option value="completed">
                <Tag icon={<CheckCircleOutlined />} color="green">Completed</Tag>
            </Select.Option>
            <Select.Option value="waiting">
                <Tag icon={<HourglassOutlined />} color="orange">Waiting</Tag>
            </Select.Option>
            <Select.Option value="processing">
                <Tag icon={<SyncOutlined />} color="blue">Processing</Tag>
            </Select.Option>
            <Select.Option value="cancelled">
                <Tag icon={<CloseCircleOutlined />} color="red">Cancelled</Tag>
            </Select.Option>
        </Select>
    )
}

export default SelectStatusCustom;